module.exports = __webpack_public_path__ + "static/media/telemedicine2.94a1a0cf.png";